import { render, staticRenderFns } from "./LawNormFormByLawsItem.vue?vue&type=template&id=0a60817b&scoped=true&"
import script from "./LawNormFormByLawsItem.vue?vue&type=script&lang=js&"
export * from "./LawNormFormByLawsItem.vue?vue&type=script&lang=js&"
import style0 from "./LawNormFormByLawsItem.vue?vue&type=style&index=0&id=0a60817b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60817b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
